import {Component} from "@angular/core";
import {
    AlertController,
    IonicPage, LoadingController,
    NavController,
    NavParams
} from "ionic-angular";
import {LoginPage} from "../login/login";
import {AccountProvider} from "../../providers/account/account";
import {CommonProvider} from "../../providers/common/common";

/**
 * Generated class for the ProfilePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: "page-profile",
    templateUrl: "profile.html",
    providers: [AccountProvider, CommonProvider]
})
export class ProfilePage {
    is_change_password = false;
    public uuid: any = null;
    model: any = {};

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public alertCtrl: AlertController,
        public loadingCtrl: LoadingController,
        private accountProvider: AccountProvider,
        private commonProvider: CommonProvider
    ) {
        this.uuid = this.commonProvider.generateGuid();

        this.accountProvider.loadProfile().subscribe(
            (resp: any) => {
                if (!resp.status) {
                    return;
                }

                const {data} = resp;

                this.model = {
                    thumbnail_url: data.thumbnail_url,
                    username: data.metas.student_username,
                    fullname: data.title,
                    email: data.metas.student_parent_email,
                    phone: data.metas.student_parent_phone,
                    address: data.metas.student_parent_address
                }
            },
            err => {
                console.log(err);
            }
        );
    }

    ionViewDidLoad() {
        console.log("ionViewDidLoad ProfilePage");
    }

    save() {
        this.accountProvider.updateProfile(this.model).subscribe(resp => {
            this.showSuccess();
        });
    }

    showSuccess() {
        const alert = this.alertCtrl.create({
            title: "Thành Công",
            subTitle: "Thông tin của bạn đã được cập nhật thành công vào hệ thống.",
            buttons: ["Đóng"]
        });
        alert.present();
    }

    signout() {
        window.localStorage.removeItem("TOKEN_KEY");
        this.navCtrl.setRoot(LoginPage);
    }


    fileChanged(e: Event) {
        let loader = this.loadingCtrl.create({
            content: "Vui lòng chờ giây lát ..."
        });
        loader.present();

        let target: HTMLInputElement = e.target as HTMLInputElement;
        for (let i = 0; i < target.files.length; i++) {
            console.log(target.files[i]);
            this.commonProvider.uploadImage(target.files[i], resp => {
                loader.dismiss();
                if (!resp.status) {
                    return;
                }

                document.getElementById(`avatar_${this.uuid}`)['value'] = '';
                this.model.thumbnail = resp.data.image;
                this.model.thumbnail_url = resp.data.image_url;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts